
import React from "react";
import ClientMonthlyTable from "views/Dashboard/ClientMonthly/Components/ClientMonthlyTable";

const ClientMonthly = () => (
  <ClientMonthlyTable />
);
export default ClientMonthly;